import React from "react"
import { StaticQuery, graphql } from "gatsby"

import Layout from "../components/layout"
import projectsStyle from "./projects.module.scss"
import aboutStyle from "./about.module.scss"

import backgroundImg from "../img/middle.png"

const About = () => {
  return (
    <StaticQuery
      query={graphql`
        query {
          allContentfulThingsILove {
            edges {
              node {
                picture {
                  file {
                    url
                  }
                  fixed(width: 10, height: 10) {
                    base64
                    tracedSVG
                    aspectRatio
                    srcWebp
                    srcSetWebp
                  }
                }
                title
                body
              }
            }
          }
        }
      `}
      render={data => (
        <div>
          <div>
            <h2 className={projectsStyle.title}>Things I love</h2>
            <div className={aboutStyle.cardContainer}>
              <ol>
                {data.allContentfulThingsILove.edges.map(edge => {
                  return (
                    <div className={aboutStyle.cardWrapper}>
                      <div className={aboutStyle.content}>
                        <div className={aboutStyle.up}>
                          <div className={aboutStyle.circle}>
                            <div className={aboutStyle.imgWrapper}>
                              <img
                                className={aboutStyle.img}
                                src={edge.node.picture.file.url}
                                alt={edge.node.title}
                              ></img>
                            </div>
                          </div>
                          <h3>{edge.node.title}</h3>
                        </div>
                        <div className={aboutStyle.down}>
                          {" "}
                          <p>{edge.node.body}</p>{" "}
                        </div>
                      </div>
                    </div>
                  )
                })}
              </ol>
            </div>
          </div>
          <div className={aboutStyle.wrapper} id="about">
            <h2 className={projectsStyle.title}>ABOUT</h2>
            <p className={aboutStyle.body}>
              My name is Sooyoung Moon. I am a computer science student at the
              University of Arizona. I am a person who enjoys exploring new
              places, listening to music, and programming something that can
              help people.
            </p>
            <p className={aboutStyle.body}>
              I am currently working for YesPlz AI as a part-time intern, taking
              classes at the University of Arizona, and training in the
              Engineering Essentials program by Goldman Sachs.
            </p>
            <p className={aboutStyle.body}>
              In 2017, I graduated with a degree in biology and worked for a
              neuroscience laboratory. While working, I realized that my passion
              lies in combining neuroscience with computer science and
              developing a cutting-edge technology. It was also during this time
              when a new wave of global excitement in AI arrived. Since then, I
              studied deep learning on my own and started at the University of
              Arizona to strengthen my knowledge in the basics of computer
              science.
            </p>
            <p className={aboutStyle.body}>
              Now, I am passionately seeking new knowledge, studying, and
              expanding my skills. I am interested in web development, data
              visualization, crawling as well as deep learning and beyond. If
              you’d like to learn more about me, work together, or just want to
              say hi, feel free to send me a message.
            </p>
          </div>
          <section className={aboutStyle.skillsets}></section>
        </div>
      )}
    />
  )
}
 
export default About;